import {
  INSERT_SEARCH_FILTER,
  CLEAR_SEARCH_FILTER,
  UN_SEARCH_FILTER,
} from './constants'

const initialState = {
  categories: [],
  businessType: [],
  isCheckedRegisCapital: false,
  registeredCapital: null,
  isCheckedYearEstablished: false,
  yearEstablished: null,
  financialScore: [],
  sustainabilityScore: [],
  operationRiskScore: [],
  riskLevelScore: [],
  offlineAssessment: [],
  isClear: false,
  regulatoryRisk: [],
}

const insertSearchFilter = action => {
  const searchFilter = action.searchFilter
  return { ...searchFilter, isClear: action.isClear }
}

const unSearchFilter = action => {
  const searchFilter = action.searchFilter
  return { ...searchFilter, isClear: action.isClear }
}

export default (state = initialState, action) => {
  switch (action.type) {
    case INSERT_SEARCH_FILTER:
      return insertSearchFilter(action)
    case CLEAR_SEARCH_FILTER:
      return { ...initialState, isClear: action.isClear }
    case UN_SEARCH_FILTER:
      return unSearchFilter(action)
    default:
      return state
  }
}
